import React from "react";
import "./TreasuryReportingTab.scss";
import { useSelector } from "react-redux";
import { CSVLink } from "react-csv";

function TreasuryReportingTab() {
  const downloadDescriptions = [
    "P&L Reporting",
    "P&L Reporting (30day forecast)",
    "P&L Reporting (60day forecast)",
    "Chart of Accounts",
  ];

  const accountingDataState = useSelector(
    (state) => state.accountingTable.accountingTable
  );

  //Printing a CSV is done below
  // Add your title here
  const titleRow = [`Charts of Accounts`];

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
    //These will be header columns
    ["Account Type", "Account ID", "Account Name", "Debit", "Credit"],
    // Add the data rows
    ...accountingDataState.map((row) => [
      row.vacctstructure.accttypename,
      row.vacctstructure.acctID,
      row.vacctstructure.firstName + " " + row.vacctstructure.lastName,
      parseInt(row.vacctstructure.balance) > 0
        ? row.vacctstructure.balance
        : "-",
      parseInt(row.vacctstructure.balance) < 0
        ? Math.abs(parseInt(row.vacctstructure.balance) * -1)
        : "-",
    ]),
  ];

  function DownloadLine({ description }) {
    return (
      <div className="reporting-download-line row">
        <div className="col-3 download-description">{description}</div>
        <div className="col-3">
          <div className="row download-type-container justify-content-center">
            <div className="col-3 download-type download-csv">
              <CSVLink data={csvData} filename={`${description}.csv`}>
                CSV
              </CSVLink>
            </div>
            {/* <div className="col-3 download-type download-xls">XLS</div>
            <div className="col-3 download-type download-pdf">PDF</div> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reporting-tab-container">
      <div className="d-flex justify-content-between header-container-liquidity">
        <div className="liquidity-tab-header">Reporting</div>
      </div>
      <div className="reporting-table-container">
        <div className="row reporting-tab-headers">
          <div className="col-3 type-background">Type</div>
          <div className="col-3 download-background">Download</div>
          <div className="col-6 empty-background"></div>
        </div>
        <div className="reporting-download-container">
          {downloadDescriptions.map((description, index) => (
            <DownloadLine key={index} description={description} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TreasuryReportingTab;
